import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const SupportPage = () => (
  <Layout>
    <SEO title="Support" />
    <h1>Support</h1>
    <h2>Common Questions</h2>
    <dl>
      <dt>Why can't the app find my printer?</dt>
      <dd>
        The app relies on Apple AirPrint compatibility. If you're on the same
        WiFi as your printer and the printer supports AirPrint it should be
        available.
      </dd>
      <dt>How do I contact the developer?</dt>
      <dd>
        <>
          You can email me at donnierayjones@gmail.com. You can also find me on{" "}
        </>
        <Link to="https://twitter.com/hidrj">Twitter</Link>.
      </dd>
    </dl>
    <p>
      <Link to="/">&lt; Home</Link>
    </p>
  </Layout>
)

export default SupportPage
